var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarGuestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5999 10.6497C10.5416 10.6414 10.4666 10.6414 10.3999 10.6497C8.93327 10.5997 7.7666 9.39974 7.7666 7.92474C7.7666 6.41641 8.98327 5.19141 10.4999 5.19141C12.0083 5.19141 13.2333 6.41641 13.2333 7.92474C13.2249 9.39974 12.0666 10.5997 10.5999 10.6497Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1171 16.1498C14.6338 17.5081 12.6671 18.3331 10.5005 18.3331C8.33379 18.3331 6.36712 17.5081 4.88379 16.1498C4.96712 15.3665 5.46712 14.5998 6.35879 13.9998C8.64212 12.4831 12.3755 12.4831 14.6421 13.9998C15.5338 14.5998 16.0338 15.3665 16.1171 16.1498Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 18.3337C15.1027 18.3337 18.8337 14.6027 18.8337 10.0003C18.8337 5.39795 15.1027 1.66699 10.5003 1.66699C5.89795 1.66699 2.16699 5.39795 2.16699 10.0003C2.16699 14.6027 5.89795 18.3337 10.5003 18.3337Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarGuestIcon);
export default __webpack_public_path__ + "static/media/sidebar-guest-icon.155039d07ab66c96003249d12494dc41.svg";
export { ForwardRef as ReactComponent };